import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-233428e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full w-full" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "__setup-timesheet __section shadow-sm bg-white mb-10"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }, " Ngày Giờ Hoạt Động - Cơ sở ", -1))
const _hoisted_5 = { class: "__section__content p-6" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "input-group flex-nowrap flex items-center justify-between mb-10" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 text-neutral-500 font-normal" }, " Giờ bắt đầu làm việc ", -1))
const _hoisted_9 = { class: "input-group flex-nowrap flex items-center justify-between mb-10" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 text-neutral-500 font-normal" }, " Giờ kết thúc làm việc ", -1))
const _hoisted_11 = { class: "input-group flex-nowrap flex items-center justify-between" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 text-neutral-500 font-normal" }, " Ngày nghỉ ", -1))
const _hoisted_13 = {
  class: "w-full",
  style: {"max-width":"300px"}
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<option value=\"2\" data-v-233428e6>Thứ 2</option><option value=\"3\" data-v-233428e6>Thứ 3</option><option value=\"4\" data-v-233428e6>Thứ 4</option><option value=\"5\" data-v-233428e6>Thứ 5</option><option value=\"6\" data-v-233428e6>Thứ 6</option><option value=\"7\" data-v-233428e6>Thứ 7</option><option value=\"8\" data-v-233428e6>Chủ nhật</option>", 7)
const _hoisted_21 = [
  _hoisted_14
]
const _hoisted_22 = { class: "input-group flex-nowrap flex items-center justify-between mb-10" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_24 = {
  key: 0,
  class: "p-4 mt-4 border border-neutral-100 rounded-xl w-full",
  style: {"max-width":"300px"}
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Remove small option", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-2 w-2",
  stroke: "currentColor",
  fill: "none",
  viewBox: "0 0 8 8"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-width": "1.5",
    d: "M1 1l6 6m0-6L1 7"
  })
], -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "__section__footer font-semibold text-neutral-600 p-6" }
const _hoisted_30 = { class: "flex justify-end" }
const _hoisted_31 = {
  key: 1,
  class: "__setup-timesheet __data bg-white rounded-2xl shadow-sm mb-10 overflow-hidden"
}
const _hoisted_32 = { class: "__data__header p-6 flex items-center justify-between" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-600 font-semibold" }, " Ngày Giờ Hoạt Động - Cơ sở ", -1))
const _hoisted_34 = { class: "__data__content text-neutral-800" }
const _hoisted_35 = { class: "grid grid-cols-2 px-6 py-4 bg-neutral-50" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500" }, "Giờ bắt đầu làm việc", -1))
const _hoisted_37 = { class: "md-down:text-right" }
const _hoisted_38 = {
  key: 0,
  class: "grid grid-cols-2 px-6 py-4"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500" }, " Giờ kết thúc làm việc ", -1))
const _hoisted_40 = { class: "md-down:text-right" }
const _hoisted_41 = { class: "grid grid-cols-2 px-6 py-4 bg-neutral-50" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500" }, "Ngày nghỉ", -1))
const _hoisted_43 = {
  key: 0,
  class: "flex items-center flex-wrap md-down:text-right w-full md-down:justify-end"
}
const _hoisted_44 = {
  key: 1,
  class: "md-down:text-right"
}
const _hoisted_45 = { key: 1 }
const _hoisted_46 = {
  key: 0,
  class: "__setup-timesheet __section shadow-sm bg-white"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }, " Lớp Bán Trú ", -1))
const _hoisted_48 = { class: "__section__content p-6" }
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = { class: "input-group flex-nowrap flex items-center justify-between mb-10" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 text-neutral-500 font-normal" }, " Lớp bán trú ", -1))
const _hoisted_52 = { class: "input-group flex-nowrap flex items-center justify-between mb-10" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 text-neutral-500 font-normal" }, " Giờ bắt đầu buổi học ", -1))
const _hoisted_54 = { class: "input-group flex-nowrap flex items-center justify-between mb-10" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 text-neutral-500 font-normal" }, " Giờ kết thúc buổi học ", -1))
const _hoisted_56 = { class: "input-group flex-nowrap flex items-center justify-between" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 text-neutral-500 font-normal" }, " Ngày nghỉ ", -1))
const _hoisted_58 = {
  class: "w-full",
  style: {"max-width":"300px"}
}
const _hoisted_59 = /*#__PURE__*/_createStaticVNode("<option value=\"2\" data-v-233428e6>Thứ 2</option><option value=\"3\" data-v-233428e6>Thứ 3</option><option value=\"4\" data-v-233428e6>Thứ 4</option><option value=\"5\" data-v-233428e6>Thứ 5</option><option value=\"6\" data-v-233428e6>Thứ 6</option><option value=\"7\" data-v-233428e6>Thứ 7</option><option value=\"8\" data-v-233428e6>Chủ nhật</option>", 7)
const _hoisted_66 = [
  _hoisted_59
]
const _hoisted_67 = { class: "input-group flex-nowrap flex items-center justify-between mb-10" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_69 = {
  key: 0,
  class: "p-4 mt-4 border border-neutral-100 rounded-xl w-full",
  style: {"max-width":"300px"}
}
const _hoisted_70 = ["onClick"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Remove small option", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-2 w-2",
  stroke: "currentColor",
  fill: "none",
  viewBox: "0 0 8 8"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-width": "1.5",
    d: "M1 1l6 6m0-6L1 7"
  })
], -1))
const _hoisted_73 = [
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = { class: "__section__footer font-semibold text-neutral-600 p-6" }
const _hoisted_75 = { class: "flex justify-end" }
const _hoisted_76 = ["disabled"]
const _hoisted_77 = {
  key: 1,
  class: "__setup-timesheet __section shadow-sm bg-white overflow-hidden"
}
const _hoisted_78 = { class: "__data__content text-neutral-800" }
const _hoisted_79 = { class: "__data__header p-6 flex items-center justify-between" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-600 font-semibold" }, " Ngày giờ hoạt động - Lớp bán trú ", -1))
const _hoisted_81 = {
  key: 0,
  class: "grid grid-cols-2 px-6 py-4 bg-neutral-50"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500" }, " Tổng số lớp bán trú ", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md-down:text-right" }, " Không có lớp bán trú ", -1))
const _hoisted_84 = [
  _hoisted_82,
  _hoisted_83
]
const _hoisted_85 = { class: "grid grid-cols-2 px-6 py-4 bg-neutral-50" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500" }, " Tổng số lớp bán trú ", -1))
const _hoisted_87 = { class: "md-down:text-right" }
const _hoisted_88 = { class: "grid grid-cols-2 px-6 py-4" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500" }, " Giờ bắt đầu buổi học ", -1))
const _hoisted_90 = { class: "md-down:text-right" }
const _hoisted_91 = { class: "grid grid-cols-2 px-6 py-4 bg-neutral-50" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500" }, " Giờ kết thúc buổi học ", -1))
const _hoisted_93 = { class: "md-down:text-right" }
const _hoisted_94 = { class: "grid grid-cols-2 px-6 py-4" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500" }, "Ngày nghỉ", -1))
const _hoisted_96 = {
  key: 0,
  class: "flex items-center flex-wrap w-full md-down:justify-end"
}
const _hoisted_97 = {
  key: 1,
  class: "md-down:text-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_VueDatepicker = _resolveComponent("VueDatepicker")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.editMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createVNode(_component_VueDatepicker, {
                        class: "input-date w-full",
                        timePicker: "",
                        placeholder: "Giờ bắt đầu làm việc",
                        autoApply: "",
                        modelValue: _ctx.start_opening_hour,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.start_opening_hour) = $event)),
                        uid: "start_opening_hour",
                        minutesIncrement: "30"
                      }, {
                        "input-icon": _withCtx(() => [
                          _createVNode(_component_DaIcon, {
                            name: "das--lock",
                            class: "h-4 w-4 text-neutral-400"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_VueDatepicker, {
                        modelValue: _ctx.end_opening_hour,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.end_opening_hour) = $event)),
                        class: "input-date w-full",
                        timePicker: "",
                        placeholder: "Giờ kết thúc làm việc",
                        autoApply: "",
                        uid: "end_opening_hour",
                        minutesIncrement: "30"
                      }, {
                        "input-icon": _withCtx(() => [
                          _createVNode(_component_DaIcon, {
                            name: "das--lock",
                            class: "h-4 w-4 text-neutral-400"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("select", {
                          class: "mt-1 block pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md input",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selected) = $event))
                        }, _hoisted_21, 512), [
                          [_vModelSelect, _ctx.selected]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      (_ctx.daySelected?.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daySelectedList, (d) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "inline-flex items-center py-0.5 pl-2 pr-0.5 rounded-full text-xs font-medium bg-blue-100 text-indigo-700 mr-1 shadow-input whitespace-nowrap",
                                key: d
                              }, [
                                _createTextVNode(_toDisplayString(d != 8 ? 'Thứ ' + d : 'Chủ nhật') + " ", 1),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-400 hover:bg-neutral-200 hover:text-neutral-500 shadow-input",
                                  onClick: ($event: any) => (_ctx.removeDay(d))
                                }, _hoisted_28, 8, _hoisted_25)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "button-p",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateOpeningHour && _ctx.updateOpeningHour(...args)))
                    }, " Lưu chỉnh sửa ")
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode(_component_DaIcon, {
                    name: "das--pen",
                    class: "h-5 w-5 cursor-pointer text-blue-600 hover:text-blue-900 active:text-blue-500",
                    onClick: _ctx.edit
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.orgOpeningHour.start_opening_hour || 'Không có'), 1)
                  ]),
                  (_ctx.orgOpeningHour.end_opening_hour)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.orgOpeningHour.end_opening_hour || 'Không có'), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    (_ctx.daySelectedList?.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daySelectedList, (d, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "whitespace-nowrap md-down:text-right"
                            }, _toDisplayString(index != 0 ? ',' : '') + " " + _toDisplayString(d != 8 ? ' Thứ ' + d : ' Chủ nhật'), 1))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_44, " Không có ngày nghỉ "))
                  ])
                ])
              ]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.mode === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          (_ctx.editDayCareMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _createVNode(_component_SwitchButton, {
                        value: _ctx.orgDayCare.has_day_care,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.orgDayCare.has_day_care) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createVNode(_component_VueDatepicker, {
                        modelValue: _ctx.start_opening_hour_DayCare,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.start_opening_hour_DayCare) = $event)),
                        class: "input-date w-full",
                        timePicker: "",
                        placeholder: "Giờ bắt đầu buổi học",
                        autoApply: "",
                        uid: "start_opening_hour_DayCare",
                        minutesIncrement: "30"
                      }, {
                        "input-icon": _withCtx(() => [
                          _createVNode(_component_DaIcon, {
                            name: "das--lock",
                            class: "h-4 w-4 text-neutral-400"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createVNode(_component_VueDatepicker, {
                        modelValue: _ctx.end_opening_hour_DayCare,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.end_opening_hour_DayCare) = $event)),
                        class: "input-date w-full",
                        timePicker: "",
                        placeholder: "Giờ kết thúc buổi học",
                        autoApply: "",
                        uid: "end_opening_hour_DayCare",
                        minutesIncrement: "30"
                      }, {
                        "input-icon": _withCtx(() => [
                          _createVNode(_component_DaIcon, {
                            name: "das--lock",
                            class: "h-4 w-4 text-neutral-400"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createElementVNode("div", _hoisted_58, [
                        _withDirectives(_createElementVNode("select", {
                          class: "mt-1 block pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md input",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedDayCare) = $event))
                        }, _hoisted_66, 512), [
                          [_vModelSelect, _ctx.selectedDayCare]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _hoisted_68,
                      (_ctx.daySelectedDayCare?.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daySelectedListDayCare, (d) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "inline-flex items-center py-0.5 pl-2 pr-0.5 rounded-full text-xs font-medium bg-blue-100 text-indigo-700 mr-1 shadow-input whitespace-nowrap",
                                key: d
                              }, [
                                _createTextVNode(_toDisplayString(d != 8 ? 'Thứ ' + d : 'Chủ nhật') + " ", 1),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-400 hover:bg-neutral-200 hover:text-neutral-500 shadow-input",
                                  onClick: ($event: any) => (_ctx.removeDayCare(d))
                                }, _hoisted_73, 8, _hoisted_70)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("button", {
                      disabled: !_ctx.end_opening_hour_DayCare || !_ctx.start_opening_hour_DayCare,
                      type: "button",
                      class: "button-p",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.updateDayCareOpeningHour && _ctx.updateDayCareOpeningHour(...args)))
                    }, " Lưu chỉnh sửa ", 8, _hoisted_76)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("div", _hoisted_79, [
                    _hoisted_80,
                    _createVNode(_component_DaIcon, {
                      name: "das--pen",
                      class: "h-5 w-5 cursor-pointer text-blue-600 hover:text-blue-900 active:text-blue-500",
                      onClick: _ctx.editDayCare
                    }, null, 8, ["onClick"])
                  ]),
                  (!_ctx.orgDayCare.has_day_care)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, _hoisted_84))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_85, [
                          _hoisted_86,
                          _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.total || 'Không có lớp bán trú'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_88, [
                          _hoisted_89,
                          _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.orgDayCare.day_care_start_opening_hour ||
									'Không có'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_91, [
                          _hoisted_92,
                          _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.orgDayCare.day_care_end_opening_hour ||
									'Không có'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_94, [
                          _hoisted_95,
                          (_ctx.daySelectedDayCare?.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daySelectedListDayCare, (d, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "whitespace-nowrap md-down:text-right"
                                  }, _toDisplayString(index != 0 ? ',' : '') + " " + _toDisplayString(d != 8 ? ' Thứ ' + d : ' Chủ nhật'), 1))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_97, " Không có ngày nghỉ "))
                        ])
                      ], 64))
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}